/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by seaster on 3/25/15.
 */

'use strict';

function SidebarController (SidebarService, PermissionsService, NotificationService) {

    var self = this;

    self.isAdmin = PermissionsService.isAdmin();

    self.sidebarItemClick = function (sidebarItem) {
        var cleanForm = !SidebarService.editService ||
            !SidebarService.editService.editorForm ||
            SidebarService.editService.editorForm.$pristine;

        if (!cleanForm) {
            NotificationService.createWarningNotification(
                'Please save or revert your changes before navigating away from this page.'
            );
        } else {
            SidebarService.setSelectedItem(sidebarItem);
        }
    };

    self.isNavItemActive = function (navItem) {
        return SidebarService.getSelectedItem() === navItem;
    };

    self.showNavItem = function (navItem) {
        return SidebarService.userHasPermissionForSidebarItem(navItem);
    };

    self.showNavItemPessimisstic = function (navItem) {
        //
        // Won't show the item unless the user has both read AND
        // write permissions for the view state.
        //
        return SidebarService.userHasRWPermissionForSidebarItem(navItem);
    };

    self.showParentNavItem = function (navChildren) {
        for (var i = 0; i < navChildren.length; i++) {
            if (self.showNavItem(navChildren[i])) {
                return true;
            }
        }

        return false;
    };

    SidebarService.setNavPermissions();
}

angular
.module('prism-ui.components.navigation')
.component('sidebarNav', {
    templateUrl: 'components/navigation/sidebar/sidebar-template.html',
    controller: SidebarController,
    bindings: {	}
});
